if (!customElements.get('right-sidebar')) {
    customElements.define(
        'right-sidebar',
        class RightSidebar extends HTMLElement {
            constructor() {
                super();
                this.dropdownTrigger = null;
                this.dropdownMenu = null;
                this.currentText = null;
                this.isOpen = false;
            }

            connectedCallback() {
                this.dropdownTrigger = this.querySelector('[data-mobile-dropdown-trigger]');
                this.dropdownMenu = this.querySelector('[data-mobile-dropdown-menu]');
                this.currentText = this.querySelector('[data-current-text]');
                
                if (this.dropdownTrigger && this.dropdownMenu) {
                    this.setupDropdown();
                }
            }

            setupDropdown() {
                // Handle trigger click
                this.dropdownTrigger.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    this.toggleDropdown();
                });

                // Handle clicks outside the dropdown
                document.addEventListener('click', (e) => {
                    if (this.isOpen && !this.contains(e.target)) {
                        this.closeDropdown();
                    }
                });

                // Handle menu item clicks
                this.dropdownMenu.addEventListener('click', (e) => {
                    if (e.target.classList.contains('sidebar-link')) {
                        this.updateCurrentText(e.target.textContent);
                        this.closeDropdown();
                    }
                });
            }

            toggleDropdown() {
                if (this.isOpen) {
                    this.closeDropdown();
                } else {
                    this.openDropdown();
                }
            }

            openDropdown() {
                this.dropdownMenu.classList.remove('hidden');
                this.dropdownTrigger.classList.add('active');
                this.isOpen = true;
            }

            closeDropdown() {
                this.dropdownMenu.classList.add('hidden');
                this.dropdownTrigger.classList.remove('active');
                this.isOpen = false;
            }

            updateCurrentText(text) {
                if (this.currentText) {
                    this.currentText.textContent = text;
                }
            }
        }
    );
}
